import { useEffect } from 'react';

const CALENDLY_URL = 'https://paystack.com/buy/private-clarity-call-sdonrr';

export default function ContactTopSection() {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://assets.calendly.com/assets/external/widget.js';
    script.async = true;
    document.head.appendChild(script);

    return () => {
      const existing = document.head.querySelector(
        'script[src="https://assets.calendly.com/assets/external/widget.js"]'
      );
      if (existing) {
        document.head.removeChild(existing);
      }
    };
  }, []);

  return (
    <section className="bg-[#FDFAF8] py-16 md:py-28 lg:py-32 pt-28 md:pt-40">
      <div className="w-full px-4 md:px-8 lg:px-12 max-w-4xl mx-auto text-center">
        {/* Eyebrow */}
        <p className="text-[#C9A84C] text-xs font-body tracking-[0.25em] uppercase mb-4">
          Let's talk
        </p>

        {/* Headline */}
        <h1 className="font-heading text-xl md:text-3xl lg:text-5xl text-[#1A1A1A] mb-6 leading-tight">
    Every transformation
    <br />
    starts with one conversation.
        </h1>

        {/* Body */}
        <p className="font-body text-sm md:text-base text-[#4A4A4A] leading-relaxed mb-10 max-w-2xl mx-auto">
          A clarity call is a 30-minute conversation to explore where you are, what you are carrying, and whether working together is the right next step.
        </p>

        {/* CTA Button */}
        <a
          href={CALENDLY_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center justify-center px-8 py-4 bg-[#D4006A] text-white text-sm font-body font-medium rounded-full hover:bg-[#B3005A] transition-colors duration-300 mb-10 w-full sm:w-auto"
        >
  Book Your Clarity Call
</a>

<p className="text-xs text-[#4A4A4A] text-center mt-2">
  <a href="https://paystack.com/buy/private-clarity-call-sdonrr" target="_blank" rel="noopener noreferrer" className="underline hover:text-[#D4006A]">Book a Private Clarity Call</a>
</p>

        {/* Calendly Inline Widget */}
        <div
          className="calendly-inline-widget w-full rounded-lg overflow-hidden border border-[#C9A84C]/20"
          data-url="https://calendly.com/mandieozee/15min"
          style={{ minWidth: '320px', height: '700px' }}
        />
      </div>
    </section>
  );
}